const u = [];
for (let e = 0; e < 256; ++e)
  u.push((e + 256).toString(16).slice(1));
function B(e, t = 0) {
  return (u[e[t + 0]] + u[e[t + 1]] + u[e[t + 2]] + u[e[t + 3]] + "-" + u[e[t + 4]] + u[e[t + 5]] + "-" + u[e[t + 6]] + u[e[t + 7]] + "-" + u[e[t + 8]] + u[e[t + 9]] + "-" + u[e[t + 10]] + u[e[t + 11]] + u[e[t + 12]] + u[e[t + 13]] + u[e[t + 14]] + u[e[t + 15]]).toLowerCase();
}
let A;
const M = new Uint8Array(16);
function j() {
  if (!A) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    A = crypto.getRandomValues.bind(crypto);
  }
  return A(M);
}
const F = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), b = { randomUUID: F };
function K(e, t, n) {
  e = e || {};
  const r = e.random ?? e.rng?.() ?? j();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, B(r);
}
function $(e, t, n) {
  return b.randomUUID && !e ? b.randomUUID() : K(e);
}
const U = (e) => {
  const t = $();
  return e ? `${e}-${t}` : t;
}, R = async (e) => {
  const t = new TextEncoder().encode(e), n = await window.crypto.subtle.digest("SHA-256", t), r = String.fromCharCode(
    ...Array.from(new Uint8Array(n))
  );
  return window.btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}, G = (e) => {
  const t = new URL(window.location.href), n = {};
  for (const r of e) {
    const o = t.searchParams.get(r);
    o && (n[r] = o);
  }
  return n;
};
var a = /* @__PURE__ */ ((e) => (e.PkceRequestCredentialsSilentlyError = "PKCE_REQUEST_CREDENTIALS_SILENTLY_ERROR", e.InitiateRedirectAuthenticationError = "INITIATE_REDIRECT_AUTHENTICATION_ERROR", e.CompleteRedirectAuthenticationError = "COMPLETE_REDIRECT_AUTHENTICATION_ERROR", e.FirstPartyValidationError = "FIRST_PARTY_VALIDATION_ERROR", e.PkceLtiRequestCredentialsSilentlyError = "PKCE_LTI_REQUEST_CREDENTIALS_SILENTLY_ERROR", e.SilentLtiAuthError = "SILENT_LTI_AUTH_ERROR", e.BreakoutLtiAuthError = "BREAKOUT_LTI_AUTH_ERROR", e.PkcePostMessageCredentialsError = "PKCE_POST_MESSAGE_CREDENTIALS_ERROR", e.BreakoutTabError = "BREAKOUT_TAB_ERROR", e.PostMessageTimeout = "POST_MESSAGE_TIMEOUT", e.PkceCredentialsExchangeError = "PKCE_CREDENTIALS_EXCHANGE_ERROR", e.PersonaUserInfoError = "PERSONA_PROFILE_ERROR", e.RefreshTokenError = "REFRESH_TOKEN_ERROR", e.BrowserStorageError = "BROWSER_STORAGE_ERROR", e.PkcePostMessageCredentialsResponseInvalid = "PKCE_POST_MESSAGE_CREDENTIALS_RESPONSE_INVALID", e.PkceCredentialsResponseInvalid = "PKCE_CREDENTIALS_RESPONSE_INVALID", e))(a || {});
class c extends Error {
  constructor(t, n, r) {
    super(n, { cause: r }), this.name = t;
  }
}
class m extends c {
  constructor(t, n, r) {
    super(
      t,
      n,
      Error(`${r.error}
 Description: ${r.error_description}`)
    );
  }
}
class d extends c {
  constructor(t, n, r) {
    super(
      t,
      n,
      Error(`Invalid response: ${JSON.stringify(r)}`)
    );
  }
}
class g extends c {
  constructor(t, n, r) {
    super(t, n, Error(`Response code: ${r.status}`));
  }
}
const p = (e) => e !== null && typeof e == "object" && "error" in e && typeof e.error == "string" && "error_description" in e, Q = (e) => e !== null && typeof e == "object" && "code" in e && "nonce" in e && "state" in e && "subject" in e && "type" in e && "message_id" in e, x = (e) => e !== null && typeof e == "object" && "code" in e && "nonce" in e && "state" in e, q = (e) => e !== null && typeof e == "object" && "access_token" in e && "refresh_token" in e && "token_type" in e && "expires_in" in e && "scope" in e, Z = (e) => e !== null && typeof e == "object" && "guid" in e && "oauth" in e, k = (e) => e !== null && typeof e == "object" && "error" in e && "error_description" in e && "alias_nonce" in e, L = (e) => "ltiAuthNonce" in e && "ltiAuthorizeUrl" in e, Y = (e) => "aliasNonce" in e, y = "/4/authorize", W = "/4/oauth/tokens", X = "/4/oauth/userinfo", J = "/3/oauth/tokens", I = "alias-nonce-cache-key";
var O = /* @__PURE__ */ ((e) => (e.AUTHORIZATION_REQUEST = "authorization_request", e.AUTHORIZATION_RESPONSE = "authorization_response", e))(O || {}), C = /* @__PURE__ */ ((e) => (e.AUTHORIZATION_REQUEST = "com.talis.persona.AUTHORIZATION_REQUEST", e.AUTHORIZATION_RESPONSE = "com.talis.persona.AUTHORIZATION_RESPONSE", e))(C || {});
const _ = (e) => {
  const { clientId: t, provider: n } = e, r = new URLSearchParams();
  return r.set("client_id", t), r.set("provider", n), r;
}, N = (e) => {
  const { redirectUri: t, codeChallenge: n, state: r, scope: o } = e, s = new URLSearchParams();
  s.set("code_challenge", n), s.set("code_challenge_method", "S256"), s.set("redirect_uri", t), s.set("response_type", "code"), s.set("state", r);
  const i = o?.split(" ") ?? [], l = [
    .../* @__PURE__ */ new Set(["openid", "refresh_token", ...i])
  ].join(" ");
  return s.set("scope", l), s;
}, ee = (e, t) => {
  const { personaOrigin: n } = e, { messageId: r } = t, o = _(e), s = N(t), i = new URLSearchParams([
    ...o,
    ...s
  ]);
  i.set("response_mode", "web_message"), i.set("message_id", r), i.set(
    "subject",
    C.AUTHORIZATION_REQUEST
  ), i.set(
    "type",
    O.AUTHORIZATION_REQUEST
  ), Y(t) && i.set("alias_nonce", t.aliasNonce);
  const l = new URL(y, n);
  return l.search = i.toString(), l;
}, D = (e, t) => {
  const { personaOrigin: n } = e;
  let r;
  L(t) ? r = new URL(t.ltiAuthorizeUrl) : r = new URL(y, n);
  const o = _(e), s = N(t), i = new URLSearchParams([
    ...o,
    ...s
  ]);
  return i.set("prompt", "none"), i.set("response_mode", "cors"), L(t) && i.set("lti_auth_nonce", t.ltiAuthNonce), r.search = i.toString(), r;
}, te = (e, t) => {
  const { personaOrigin: n } = e, r = _(e), o = N(t), s = new URLSearchParams([
    ...r,
    ...o
  ]), i = new URL(y, n);
  return i.search = s.toString(), i;
}, re = (e, t) => {
  const { personaOrigin: n } = e, { code: r, codeVerifier: o, nonce: s, redirectUri: i, state: l } = t, z = new URL(W, n), h = _(e);
  return h.set("code", r), h.set("code_verifier", o), h.set("grant_type", "authorization_code"), h.set("nonce", s), h.set("redirect_uri", i), h.set("state", l), { exchangeUrl: z, exchangeBody: h };
}, ne = (e) => new URL(X, e), oe = (e) => {
  const { personaOrigin: t, refreshToken: n, userGuid: r } = e, o = new URL(J, t), s = new URLSearchParams();
  return s.set("grant_type", "refresh_token"), s.set("client_id", r), s.set("refresh_token", n), { refreshTokenUrl: o, refreshTokenBody: s };
}, se = async (e) => {
  const { personaOrigin: t, accessToken: n } = e, r = ne(t);
  try {
    const o = await fetch(r, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${n}`
      }
    }), s = await o.json();
    if (!o.ok)
      throw p(s) ? new m(
        a.PersonaUserInfoError,
        "Unsuccessful request for Persona user information",
        s
      ) : new g(
        a.PersonaUserInfoError,
        "Unsuccessful request for Persona user information",
        o
      );
    if (!Z(s))
      throw new d(
        a.PersonaUserInfoError,
        "Invalid response when requesting Persona user information",
        s
      );
    return s;
  } catch (o) {
    throw o instanceof c ? o : new c(
      a.PersonaUserInfoError,
      "An unspecified error occured when requesting Persona user information",
      o
    );
  }
};
class f extends Error {
}
f.prototype.name = "InvalidTokenError";
function ae(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function ie(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return ae(t);
  } catch {
    return atob(t);
  }
}
function ce(e, t) {
  if (typeof e != "string")
    throw new f("Invalid token specified: must be a string");
  t || (t = {});
  const n = t.header === !0 ? 0 : 1, r = e.split(".")[n];
  if (typeof r != "string")
    throw new f(`Invalid token specified: missing part #${n + 1}`);
  let o;
  try {
    o = ie(r);
  } catch (s) {
    throw new f(`Invalid token specified: invalid base64 for part #${n + 1} (${s.message})`);
  }
  try {
    return JSON.parse(o);
  } catch (s) {
    throw new f(`Invalid token specified: invalid json for part #${n + 1} (${s.message})`);
  }
}
const ue = (e) => {
  const { active_pid: t } = ce(e);
  return t;
}, le = (e, t, n) => ({
  ...e,
  code: t.code,
  codeVerifier: n,
  nonce: t.nonce
}), he = async (e, t) => {
  const { exchangeUrl: n, exchangeBody: r } = re(
    e,
    t
  );
  try {
    const o = await window.fetch(n, {
      method: "POST",
      body: r
    }), s = await o.json();
    if (!o.ok)
      throw p(s) ? new m(
        a.PkceCredentialsExchangeError,
        "Unsuccessful response from token exchange",
        s
      ) : new g(
        a.PkceCredentialsExchangeError,
        "Unsuccessful response from token exchange",
        o
      );
    if (!q(s))
      throw new d(
        a.PkceCredentialsExchangeError,
        "Invalid response from token exchange",
        s
      );
    return s;
  } catch (o) {
    throw o instanceof c ? o : new c(
      a.PkceCredentialsExchangeError,
      "Unspecified error from token exchange",
      o
    );
  }
}, E = async (e, t, n, r) => {
  const o = le(
    e,
    t,
    r
  ), s = await he(
    n,
    o
  ), i = await se({
    personaOrigin: n.personaOrigin,
    accessToken: s.access_token
  }), l = ue(
    s.access_token
  );
  return {
    access_token: s.access_token,
    refresh_token: s.refresh_token,
    active_pid: l,
    persona_guid: i.guid,
    persona_scopes: i.oauth.scopes,
    persona_profile: i.profile
  };
}, P = {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
  get(e) {
    const t = sessionStorage.getItem(e);
    return t == null ? null : JSON.parse(t);
  },
  save(e, t) {
    sessionStorage.setItem(e, JSON.stringify(t));
  },
  remove(e) {
    sessionStorage.removeItem(e);
  }
}, de = async (e) => {
  const { refreshTokenUrl: t, refreshTokenBody: n } = oe(e);
  try {
    const r = await fetch(t, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: n
    }), o = await r.json();
    if (!r.ok)
      throw p(o) ? new m(
        a.RefreshTokenError,
        "Unsuccessful response from refresh token request",
        o
      ) : new g(
        a.RefreshTokenError,
        "Unsuccessful response from refresh token request",
        r
      );
    if (!q(o))
      throw new d(
        a.RefreshTokenError,
        "Invalid response from refresh token request",
        o
      );
    return o;
  } catch (r) {
    throw r instanceof c ? r : new c(
      a.RefreshTokenError,
      "Unspecified error from refresh token request",
      r
    );
  }
}, we = (e, t) => {
  const { subject: n, type: r, messageId: o, state: s } = t;
  if (e.subject !== n)
    throw new c(
      a.PkcePostMessageCredentialsResponseInvalid,
      "Subject does not match"
    );
  if (e.type !== r)
    throw new c(
      a.PkcePostMessageCredentialsResponseInvalid,
      "Type does not match"
    );
  if (e.message_id !== o)
    throw new c(
      a.PkcePostMessageCredentialsResponseInvalid,
      "Message ID does not match"
    );
  if (e.state !== s)
    throw new c(
      a.PkcePostMessageCredentialsResponseInvalid,
      "State does not match"
    );
}, H = (e, t) => {
  if (e.state !== t.state)
    throw new c(
      a.PkceCredentialsResponseInvalid,
      "State does not match"
    );
}, fe = async (e, t) => {
  const n = D(
    e,
    t
  ), r = await Re(n);
  return H(r, t), r;
}, Re = async (e) => {
  try {
    const t = await window.fetch(e, {
      method: "GET",
      credentials: "include"
    }), n = await t.json();
    if (!t.ok)
      throw p(n) ? new m(
        a.PkceRequestCredentialsSilentlyError,
        t.status === 400 ? "Unsuccessful response when requesting credentials for silent authentication - this is expected for a user with no session" : "Unsuccessful response when requesting credentials for silent authentication",
        n
      ) : new g(
        a.PkceRequestCredentialsSilentlyError,
        "Unsuccessful response when requesting credentials for silent authentication",
        t
      );
    if (!x(n))
      throw new d(
        a.PkceRequestCredentialsSilentlyError,
        "Invalid response when requesting credentials for silent authentication",
        n
      );
    return n;
  } catch (t) {
    throw t instanceof c ? t : new c(
      a.PkceRequestCredentialsSilentlyError,
      "Unspecified error when requesting credentials for silent authentication",
      t
    );
  }
}, Ee = (e, t) => {
  const n = te(
    e,
    t
  );
  try {
    window.location.assign(n.toString());
  } catch (r) {
    throw new c(
      a.InitiateRedirectAuthenticationError,
      "Unspecified error requesting redirection to Persona",
      r
    );
  }
}, me = () => new URL("/oauth/web_message", window.location.origin).toString(), w = (e, t) => ({
  clientId: e.clientId,
  provider: e.provider,
  messageId: U("message"),
  redirectUri: t ?? me(),
  codeChallenge: U("challenge"),
  state: U("state")
}), ge = (e, t) => new Promise((n, r) => {
  const o = () => {
    window.removeEventListener("message", i);
  }, s = setTimeout(() => {
    o(), r(
      new c(
        a.PostMessageTimeout,
        "Timeout waiting for message"
      )
    );
  }, t), i = (l) => {
    l.origin === e && (clearTimeout(s), o(), n(l));
  };
  window.addEventListener("message", i);
}), V = async (e, t) => {
  const n = pe(
    e,
    t
  );
  try {
    return await _e(
      e,
      t
    );
  } finally {
    n.close();
  }
}, pe = (e, t) => {
  const n = ee(
    e,
    t
  ).toString(), r = window.open(n);
  if (!r)
    throw new c(
      a.BreakoutTabError,
      "Failed to open breakout tab to fetch PKCE credentials"
    );
  return r;
}, _e = async (e, t) => {
  const { personaOrigin: n, timeoutMilliseconds: r } = e, o = await ge(
    n,
    r
  );
  if (Q(o.data)) {
    const s = {
      subject: C.AUTHORIZATION_RESPONSE,
      type: O.AUTHORIZATION_RESPONSE,
      messageId: t.messageId,
      state: t.state
    };
    return we(
      o.data,
      s
    ), o.data;
  } else
    throw new d(
      a.PkcePostMessageCredentialsError,
      "Unspecified error from PKCE postMessage request credentials response",
      o.data
    );
}, ke = async (e, t = !1) => {
  t || v();
  const n = w(e), r = await fe(
    e,
    n
  ), o = await R(
    n.codeChallenge
  );
  return E(
    n,
    r,
    e,
    o
  );
}, ye = (e, t, n) => {
  v();
  const r = w(e, t), o = {
    codeChallenge: r.codeChallenge,
    redirectUri: t,
    personaConfig: e,
    appState: n
  };
  try {
    P.save(r.state, o);
  } catch (s) {
    throw new c(
      a.BrowserStorageError,
      "Unable to initiate redirect authentication. Unable to store state in browser storage.",
      s
    );
  }
  Ee(e, r);
}, Oe = async () => {
  v();
  const { code: e, state: t, nonce: n } = G(["code", "state", "nonce"]);
  if (!t || !e || !n)
    throw new c(
      a.CompleteRedirectAuthenticationError,
      "Unable to retrieve state, code or nonce from query params."
    );
  let r;
  try {
    r = P.get(t);
  } catch (l) {
    throw new c(
      a.BrowserStorageError,
      "Unable to complete redirect authentication. Retrieving state from browser storage failed.",
      l
    );
  }
  if (!r)
    throw new c(
      a.BrowserStorageError,
      "Unable to complete redirect authentication. State retrieved from browser storage was empty."
    );
  P.remove(t);
  const o = await R(r.codeChallenge), s = w(
    r.personaConfig,
    r.redirectUri
  );
  return {
    loginData: await E(
      s,
      { code: e, nonce: n },
      r.personaConfig,
      o
    ),
    appState: r.appState
  };
}, v = () => {
  if (!(window.top === window.self))
    throw new c(
      a.FirstPartyValidationError,
      "Authentication method is only supported in first-party contexts."
    );
}, Ce = async (e) => de(e), Ne = async (e) => {
  const t = w(e), n = await V(
    e,
    t
  ), r = await R(
    t.codeChallenge
  );
  return await E(
    t,
    n,
    e,
    r
  );
}, S = /* @__PURE__ */ new Map(), Se = (e, t) => {
  S.set(e, t);
}, Ae = (e) => S.get(e), Ue = (e) => {
  S.delete(e);
}, Ie = () => {
  S.clear();
}, T = {
  setItem: Se,
  getItem: Ae,
  removeItem: Ue,
  clear: Ie
}, Pe = async (e, t) => {
  const n = D(
    e,
    t
  ), r = await Te(n);
  return k(r) || H(r, t), r;
}, Te = async (e) => {
  try {
    const t = await window.fetch(e, {
      method: "GET"
    }), n = await t.json();
    if (!t.ok && t.status === 404 && k(n))
      return n;
    if (!x(n))
      throw new d(
        a.PkceLtiRequestCredentialsSilentlyError,
        "Invalid response from PKCE LTI silent authorization request",
        n
      );
    return n;
  } catch (t) {
    throw t instanceof c ? t : new c(
      a.PkceLtiRequestCredentialsSilentlyError,
      "Unspecified error from PKCE LTI silent authorization request",
      t
    );
  }
}, ve = async (e) => {
  const { personaConfig: t, ltiAuthNonce: n, ltiAuthorizeUrl: r } = e, o = w(t), s = {
    ...o,
    ltiAuthNonce: n,
    ltiAuthorizeUrl: r
  }, i = await Pe(
    t,
    s
  );
  if (k(i))
    throw T.setItem(I, i.alias_nonce), new c(
      a.SilentLtiAuthError,
      "No Persona user found for VLE alias, breakout login required - this is expected for first time authentication inside the VLE or if the alias has been manually deleted."
    );
  const l = await R(
    o.codeChallenge
  );
  return E(
    o,
    i,
    t,
    l
  );
}, be = async (e) => {
  const t = T.getItem(I);
  if (!t)
    throw new c(
      a.BreakoutLtiAuthError,
      "Breakout auth called before silent auth attempt"
    );
  try {
    const n = w(e), r = {
      ...n,
      aliasNonce: t
    }, o = await V(
      e,
      r
    ), s = await R(
      n.codeChallenge
    );
    return await E(
      n,
      o,
      e,
      s
    );
  } finally {
    T.removeItem(I);
  }
};
export {
  m as PersonaPadlockApiError,
  d as PersonaPadlockApiInvalidResponseError,
  g as PersonaPadlockApiUnknownError,
  c as PersonaPadlockError,
  a as PersonaPadlockErrorType,
  Ne as authenticateViaBreakout,
  ve as authenticateVleUserSilently,
  be as authenticateVleUserViaBreakout,
  Oe as completeRedirectAuthentication,
  ye as initiateRedirectAuthentication,
  Ce as refreshAccessToken,
  ke as silentlyAuthenticate,
  v as validateIsFirstPartyContext
};
